/**
 * @desc 频道树
 */
import {
  ChannelTreeDetail,
  ChannelTreeQuery
} from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryChannelTreeParameter = ChannelTreeQuery

const method = 'GET'
const url = '/trade/channel/tree'

export const queryChannelTreeApi = (
  params?: QueryChannelTreeParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<ChannelTreeDetail>>({
    method,
    url,
    params,
    ...config
  })
}

queryChannelTreeApi.method = method
queryChannelTreeApi.url = url
